module.exports = __webpack_public_path__ + "static/media/logo_anteia.9d7951bd.png";